import React from "react";
import { Form, FormGroup } from "reactstrap";

import { ZoneFormik } from "./lib/useZoneFormik";
import { tooltips } from "../../../../lib/utils/tooltips";

import { Input } from "../../Input/Input";
import { TagInput } from "../../TagInput/TagInput";
import {
  LabelDirectionType,
  LabelWithInformationBox,
} from "../../LabelWithInformationBox/LabelWithInformationBox";

interface Props {
  formik: ZoneFormik;
  informationBoxDirection?: LabelDirectionType;
}

export const ZoneForm = (props: Props) => {
  const { formik, informationBoxDirection } = props;

  return (
    <Form className="ZoneForm">
      <FormGroup>
        <LabelWithInformationBox
          for="name"
          title="Name"
          message={tooltips.workplaces.name}
          direction={informationBoxDirection}
        />
        <Input
          type="text"
          id="name"
          name="name"
          value={formik.values.name}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          isTouched={formik.touched.name}
          errorMessage={formik.errors.name}
          invalid={!!formik.errors.name && formik.touched.name}
        />
      </FormGroup>
      <FormGroup>
        <LabelWithInformationBox
          for="description"
          title="Description"
          message={tooltips.workplaces.description}
          direction={informationBoxDirection}
        />
        <Input
          type="text"
          id="description"
          name="description"
          value={formik.values.description}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </FormGroup>
      <TagInput
        value={formik.values.tags || []}
        direction={informationBoxDirection}
        onChange={(tags) => {
          formik.setFieldValue("tags", tags);
          formik.setFieldTouched("tags");
        }}
      />
    </Form>
  );
};
